import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C34InlineMediaCardProps = RenderingProps<
  C34InlineMediaCardFields,
  C34InlineMediaCardParams,
  C34InlineMediaCardPlaceholder
>;

export type C34InlineMediaCardFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
  Image?: ImageField;
  Icon?: KeyValuePair;
};

export type C34InlineMediaCardParams = {
  Border?: string;
  HideAssetOnMobile?: string;
  HeadlineTag?: string;
  Elevation?: string;
  IconSize?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export interface C34InlineMediaCardPlaceholder {
  'inline-media-card-{*}'?: {
    componentName?: string;
  }[];
}
